import React, { useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import gif from "../../../Components/RFQ/assets/images/1.gif";
import styles from "../HelpSection.module.css";

const HelpRFQ = () => {
  const [activeKey, setActiveKey] = useState("0");

  const toggleKey = (key) => {
    setActiveKey((prevKey) => (prevKey === key ? null : key));
  };

  const renderToggleHeader = (key, title) => (
    <Accordion.Toggle
      as={Card.Header}
      eventKey={key}
      onClick={() => toggleKey(key)}
      className="d-flex justify-content-between align-items-center"
      style={{ cursor: "pointer" }}
    >
      <span>{title}</span>
      <i className={`fa fa-chevron-${activeKey === key ? "up" : "down"}`} />
    </Accordion.Toggle>
  );

  return (
    <div className={styles.HelpAddLanes}>
      {/* 🚨 Note section */}
      <div className={styles.HelpShortlistLsp}>
        <div className="alert alert-warning my-2">
          <h6>Note:</h6>
          <ul className="m-0 pl-2">
            <li>
              This screen provides detailed info about the rate card and ongoing
              RFQ rounds.
            </li>
            <li>
              You can track procurement details, view notifications, and stay
              updated on round status.
            </li>
          </ul>
        </div>
      </div>

      {/* 📌 Accordion Section */}
      <Accordion activeKey={activeKey}>
        {/* Rate Card Overview */}
        <Card className={styles.accordionCard}>
          {renderToggleHeader("0", "Rate Card Overview")}
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <ul className="list-group">
                <li className="list-group-item">
                  Procurement-level details like:
                  <ul>
                    <li>Procurement Name</li>
                    <li>Round Status</li>
                    <li>Location</li>
                  </ul>
                </li>
                <li className="list-group-item">
                  Contact details:
                  <ul>
                    <li>Email</li>
                    <li>Phone</li>
                    <li>Headquarters address</li>
                  </ul>
                </li>
                <li className="list-group-item">
                  Notifications section highlights new updates with:
                  <img
                    src={gif}
                    style={{ width: "30px", marginLeft: "8px" }}
                    alt="New"
                  />
                </li>
                <li className="list-group-item">
                  Round-level info like:
                  <ul>
                    <li>Round name</li>
                    <li>Start & End date</li>
                    <li>Status</li>
                  </ul>
                </li>
                <li className="list-group-item">
                  Active rounds show:{" "}
                  <span className="badge badge-primary ml-2">
                    Round (round no.)
                  </span>
                </li>
                <li className="list-group-item">
                  Completed rounds show:{" "}
                  <span className="badge badge-success ml-2">Completed</span>
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {/* RFQ Documents */}
        <Card className={styles.accordionCard}>
          {renderToggleHeader("1", "RFQ Documents")}
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <ul className="list-group">
                <li className="list-group-item">
                  Documents shared by the company with transporters.
                </li>
                <li className="list-group-item">
                  May include company policies, terms & conditions, and
                  contracts.
                </li>
                <li className="list-group-item">
                  Click{" "}
                  <button
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "rgb(57, 49, 133)",
                      color: "white",
                      fontSize: "14px",
                    }}
                  >
                    <i className="fa fa-download mr-1"></i>Download
                  </button>{" "}
                  to save a copy to your system.
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {/* Procurement Schedule */}
        <Card className={styles.accordionCard}>
          {renderToggleHeader("2", "Procurement Schedule")}
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <ul className="list-group">
                <li className="list-group-item">
                  Displays the procurement timeline.
                </li>
                <li className="list-group-item">
                  Includes key dates: submission deadlines, round-wise uploads,
                  etc.
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        {/* Upload Documents */}
        <Card className={styles.accordionCard}>
          {renderToggleHeader("3", "Upload Documents")}
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              <ul className="list-group">
                <li className="list-group-item">
                  This section is used by transporters to upload
                  client-requested input documents.
                </li>
                <li className="list-group-item">
                  Click{" "}
                  <button className="btn btn-success btn-sm mx-1">
                    + Upload Documents
                  </button>{" "}
                  to view the upload modal.
                </li>
              </ul>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default HelpRFQ;
